import React, { useRef, useCallback, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";
import SliderCard from "./SliderCard";

const ImageSlider = ({ cards, title }) => {
	const cardArray = cards ? JSON.parse(cards) : [];

	if (!cardArray.length) {
		return;
	}
	
	const swiperRef = useRef(null);
	const [isEnd, setIsEnd] = useState(false);
	const [isBeginning, setIsBeginning] = useState(true);

	const prevSlide = useCallback(() => {
		swiperRef.current?.swiper.slidePrev();
	}, [swiperRef]);

	const nextSlide = useCallback(() => {
		swiperRef.current?.swiper.slideNext();
	}, [swiperRef]);

	const handleSlideChange = useCallback((swiper) => {
		setIsEnd(swiper.isEnd);
		setIsBeginning(swiper.isBeginning);
	}, []);


	return (
		<>
			<div className="image-slider-block__header">
				{title && <h2 className="image-slider-block__header__title">{title}</h2> }
				<div className="button-container">
					<button
						className={`swiper__button prev button-reset ${isBeginning ? 'disabled' : ''}`}
						aria-label="Previous slide"
						onClick={prevSlide}
						disabled={isBeginning}
					>
					</button>
					<button
						className={`swiper__button next button-reset ${isEnd ? 'disabled' : ''}`}
						aria-label="Next slide"
						onClick={nextSlide}
						disabled={isEnd}
					>
					</button>
				</div>
			</div>
			<Swiper
				ref={swiperRef}
				modules={[Navigation, A11y]}
				spaceBetween={20}
				slidesPerView={"auto"}
				navigation={{
					nextEl: ".button-next",
					prevEl: ".button-prev",
				}}
				onSlideChange={handleSlideChange}
				className="image-slider"
			>
				{cardArray.map((card, index) => (
					<SwiperSlide key={index}>
						<SliderCard {...card} />
					</SwiperSlide>
				))}
			</Swiper>
		</>
	);
};

export default ImageSlider;
